import React, { FC, useEffect } from "react";
import { Route } from "react-router-dom";
import PrivateRoute, { PrivateRouteProps } from "routes/privateRoute";
import { Helmet } from "react-helmet";
import { AppRoute } from "routes";

const APP_TITLE = process.env.REACT_APP_TITLE;

type RouteWrapperProps = FC<PrivateRouteProps | any> | typeof Route;

const onBackSpace = (e: KeyboardEvent) => {
  const tagName: string = (e.target as HTMLElement).tagName;

  if (e.keyCode === 8 || e.key === 'Backspace') {
    if (!['INPUT', 'TEXTAREA'].includes(tagName)) {
      e.preventDefault();
      e.returnValue = false;

      return false;
    }
  }
};

const RouteWrapper: FC<AppRoute> = (props: AppRoute) => {
  const { component: Component, layout, title, isPrivate, ...rest } = props;

  const RouteComponent: RouteWrapperProps = isPrivate ? PrivateRoute : Route;
  const Layout: FC<RouteWrapperProps | {}> = !layout ? ({ children }) => <>{children}</> : layout;

  useEffect(() => {
    window.addEventListener('keydown', onBackSpace);

    return () => {
      window.removeEventListener('keydown', onBackSpace)
    };
  }, []);

  return (
    <RouteComponent
      {...rest}
      render={(props: RouteWrapperProps) => (
        <Layout {...props}>
          {title && (
            <Helmet>
              <title>
                {APP_TITLE} - {title}
              </title>
            </Helmet>
          )}
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

export default RouteWrapper;
